import { render, staticRenderFns } from "./DetailCompanyType.vue?vue&type=template&id=c1676fc8&scoped=true&"
import script from "./DetailCompanyType.vue?vue&type=script&lang=js&"
export * from "./DetailCompanyType.vue?vue&type=script&lang=js&"
import style0 from "./DetailCompanyType.vue?vue&type=style&index=0&id=c1676fc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1676fc8",
  null
  
)

export default component.exports